import { useCallback } from 'react';
import { usePatientCard } from '../../hooks/usePatientCard';
import { useToast } from '../../providers/ToastProvider';
import type { OpenVirtualAppointmentsNowResult } from '../../services/virtualAppointments';
import { OpenVirtualAppointmentsNowModal } from './OpenVirtualAppointmentsNowModal';
import { addVasToast } from './openNowOutcome';
import { openNowScopeFor } from './openNowScope';

interface PatientAddVasModalProps {
    patientId: string;
    onClose: () => void;
    /** Runs after the toast and the patient card refresh, instead of onClose. */
    onAdded?: () => void;
}

// "Add VAs" outside a task: scoped by the patient's status, the outcome is a toast and a card refresh.
export function PatientAddVasModal({ patientId, onClose, onAdded }: PatientAddVasModalProps) {
    const { data: card, refetch } = usePatientCard(patientId);
    const scope = openNowScopeFor(card?.status?.internalCaseStatus ?? null);
    const { showToast } = useToast();

    const handleOpened = useCallback(
        (result: OpenVirtualAppointmentsNowResult) => {
            const toast = addVasToast(result);
            if (toast) showToast(toast.message, toast.tone);
            void refetch();
            (onAdded ?? onClose)();
        },
        [showToast, refetch, onAdded, onClose]
    );

    return (
        <OpenVirtualAppointmentsNowModal
            patientId={patientId}
            allowMoveOnly={scope.allowMoveOnly}
            canOpenNow={scope.canOpenNow}
            onClose={onClose}
            onOpened={handleOpened}
        />
    );
}
